import CSS from "./static/css/PhotoInfoContainerSet.module.css";
import { joinedEventType } from "../../static/interface/PhotoList.interface";
import EventButtonSet from "../EventButtonSet/EventButtonSet";
import PhotoInfoCard from "../PhotoInfoCard/PhotoInfoCard";
import { usePhotoDetailDataSetter_shootData_interface } from "../../static/interface/usePhotoDetailDataSetter.interface";
import ImageZipDownload from "../../../../Component/Elements/ImageZipDownload/ImageZipDownload";
import SelectImageVersion from "../SelectImageVersion/SelectImageVersion";

const PhotoInfoContainerSet = (
    {
        shoot_data,

        isPrintDownloadBtn,
        upload_date,
        brand_id,
        upload_file_pk,

        // [isEventApplication 제거 - 2026-05-06 khm] 전달만 하던 props
        // isEventApplication,
        isPrintProductRequestBtn,
        scheduleId,
        joined_event,
    }:{
        shoot_data: usePhotoDetailDataSetter_shootData_interface;

        isPrintDownloadBtn: boolean;
        upload_date: string;
        brand_id: number;
        upload_file_pk: number;

        // [isEventApplication 제거 - 2026-05-06 khm] 전달만 하던 props
        // isEventApplication: boolean;
        isPrintProductRequestBtn: boolean;
        scheduleId: number;
        joined_event: joinedEventType;
    }
) => {
    return(
        <div className={CSS.l_PhotoInfoContainerSet_main}>
            <SelectImageVersion />

            <div className={CSS.l_PhotoInfoContainerSet_container}>
                <PhotoInfoCard
                    shoot_data={shoot_data}
                />
            </div>

            <div className={CSS.l_webBtnContainer}>
                {
                    isPrintDownloadBtn
                    &&  <ImageZipDownload
                            brand_id={brand_id}
                            upload_file_pk={upload_file_pk}
                        />
                }

                <EventButtonSet
                    // [isEventApplication 제거 - 2026-05-06 khm] EventButtonSet으로의 전달
                    // isEventApplication={isEventApplication}
                    isPrintProductRequestBtn={isPrintProductRequestBtn}

                    scheduleId={scheduleId}
                    upload_date={upload_date}
                    joined_event={joined_event}
                />
            </div>
        </div>
    )
}

export default PhotoInfoContainerSet;